import type { ClickoutUrl } from '@/helpers/clickout-helper';

import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useUserAgent } from '@/helpers/composables/useUserAgent';

export function setTubiAffiliationTags(clickoutUrl: ClickoutUrl, providerId: number) {
	const languageStore = useLanguageStore();
	const { deviceOs } = useUserAgent();

	if (providerId !== 73 || languageStore.country !== 'GB') return;

	if (deviceOs.value === 'ios') clickoutUrl.set('uct_ua', 'ios');
	if (deviceOs.value === 'android') clickoutUrl.set('uct_ua', 'and');
}
